import { Injectable } from "@angular/core";
import { Api } from "../api/api";

import { UserDetail, Me, User, DiscloseImg } from "../../models/user";
import { FixedPhrase } from "../../models/fixedPhrase";

import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import { MasterData } from "../../models/master-data";
import { Withdraw } from "../../models/withdraw";
import {
  LocalstorageProvider,
  KEYS,
} from "../../providers/localstorage/localstorage";
import { AlertController } from "ionic-angular";
import { Question } from "../../models/question";

export class SearchParamsToday {
  age: { min_range: number; max_range: number };
  today_meeting_location: string[];
  purpose: string[];
}

export class SearchParams {
  recent_register: boolean;
  age: { min_range?: number; max_range?: number };
  residence_location: string[];
  body_type: string[];
  business_type: string[];
  lookses: string[];
  personality: string[];
  purpose: string[];
  last_login_time: string[];
  income_type: string[];
  height: { min_range?: number; max_range?: number };
  before_meeting: string[];
  education_type: string[];
  hometown: string[];
  drinking_type: string[];
  cigarette_type: string[];
  holiday_type: string[];
  asset_proved: boolean;
  income_proved: boolean;
  top_photo: string;
  sub_photos: string;
  // bust_type: string[];
  self_introduction: string;
  is_royal_option: boolean;
  future_dream: boolean;
  register_reason: string[];
  question_existence: boolean;
  video: boolean;
}
export const DEFAULT_REPLY_PHRASE: string = "♥ いいねありがとう";

export class SearchParamsMeeting {
  date: any;
  age: { min_range: number; max_range: number };
  meeting_location: string[];
  purpose: string[];
}

export class SearchParamsBoards {
  date: any;
  board_areas: string[];
  board_purposes: string;
  age: { min_range: number; max_range: number };
  lookses: string[];
  body_types: string[];
  sort_by: { property: string; order: string };
}

export class SearchColumn {
  id: string;
  typeFunctionName: string;
  name: string;
  hide: boolean;
  isRange?: boolean;
  isOver?: boolean;
  suffix?: string;
}

@Injectable()
export class UserProvider {
  constructor(
    public api: Api,
    public localhostProvider: LocalstorageProvider,
    public alertCtrl: AlertController
  ) {}

  loadMe(): Observable<Me> {
    return this.api.get("me").map((me) => new Me(me));
  }

  updateCampaignSwipeNum(swipeNum: number): Observable<any> {
    return this.api.put("me/campaign_swipe_num", {
      campaign_swipe_num: swipeNum,
    });
  }

  updateAdjustStatus(status: string): Observable<any> {
    return this.api.put("me/update_adjust_status", { adjust_status: status });
  }

  updateWebTrackToken(token: string): Observable<any> {
    return this.api.put("me/update_web_track_token", {
      web_track_token: token,
    });
  }

  updateProperty(data: any): Observable<any> {
    return this.api.put("me/property", {
      user_property: data,
    });
  }

  updateEmail(email: String): Observable<any> {
    return this.api.put("me/email", {
      email: email,
    });
  }

  updateImage(url: string, order: number): Observable<any> {
    return this.api.put("me/images", {
      image: {
        image_url: url,
        order: order,
      },
    });
  }

  createQuestions(questions: Question[]): Observable<any> {
    return this.api.post("me/questions", {
      questions: questions,
    });
  }

  updateQuestions(questions: Question[]): Observable<any> {
    return this.api.put("me/questions/update_all", {
      questions: questions,
    });
  }

  mainImage(imageId: number): Observable<any> {
    return this.api.put("me/images/main", {
      image: {
        imageId: imageId,
      },
    });
  }

  deleteImage(imageId: number): Observable<any> {
    return this.api.delete("me/images/" + imageId);
  }

  loadUser(id: number): Observable<UserDetail> {
    return this.api.get("users/" + id).map((user) => new UserDetail(user));
  }

  loadGuests(
    page: number,
    params: SearchParams,
    userIds: number[],
    sort?: string
  ): Observable<User[]> {
    console.log(userIds);
    return this.load("guests", page, params, userIds, sort).map((guests) =>
      guests.map((guest) => new User(guest))
    );
  }

  loadCasts(
    page: number,
    params: SearchParams,
    userIds?: number[],
    sort?: string
  ): Observable<User[]> {
    return this.load("casts", page, params, userIds, sort).map((casts) =>
      casts.map((cast) => new User(cast))
    );
  }

  loadCastsForTutorial(
    page: number,
    params: SearchParams,
    userIds?: number[],
    sort?: string
  ): Observable<User[]> {
    let jsonParam: any = { page: page, query: JSON.stringify(params) };
    return this.api
      .getCompleteResponse("users/casts", jsonParam)
      .map((resp) => {
        this.localhostProvider.removeValue(KEYS.SearchLength);
        this.localhostProvider.setValue(
          KEYS.SearchLength,
          resp.headers.get("total-pages")
        );
        return resp.body.map((user) => new User(user));
      });
  }

  loadTutorialFemales(
    page: number,
    params: SearchParams,
    userIds?: number[]
  ): Observable<User[]> {
    return this.load("tutorial_casts", page, params, userIds).map((casts) =>
      casts.map((cast) => new User(cast))
    );
  }

  loadDailySwipeGuests(params: SearchParams): Observable<User[]> {
    return this.noPageLoad("daily_swipe_guests", params).map((guests) =>
      guests.map((guest) => new User(guest))
    );
  }

  loadRichSwipeMales(params: SearchParams): Observable<User[]> {
    return this.noPageLoad("rich_swipe_males", params).map((males) =>
      males.map((males) => new User(males))
    );
  }

  loadDailySwipeCasts(params: SearchParams): Observable<User[]> {
    return this.noPageLoad("daily_swipe_casts", params).map((casts) =>
      casts.map((cast) => new User(cast))
    );
  }

  loadPremiumSwipeGuests(
    params: SearchParams,
    page: number
  ): Observable<User[]> {
    return this.load("premium_swipe_guests", page, params, []).map((guests) =>
      guests.map((guest) => new User(guest))
    );
  }

  loadOnedariSwipeGuests(
    params: SearchParams,
    page: number
  ): Observable<User[]> {
    return this.load("onedari_swipe_guests", page, params, []).map((guests) =>
      guests.map((guest) => new User(guest))
    );
  }

  loadMatchedCasts(): Observable<User[]> {
    return this.api
      .get("users/matched_casts")
      .map((matchedCasts) =>
        matchedCasts.map((matchedCast) => new User(matchedCast))
      );
  }

  loadHideUsers(page: number): Observable<User[]> {
    return this.api
      .getCompleteResponse("hides", {
        page: page,
      })
      .map((resp) => {
        this.localhostProvider.removeValue(KEYS.HideListLength);
        this.localhostProvider.setValue(
          KEYS.HideListLength,
          resp.headers.get("total-pages")
        );
        return resp.body.map((user) => new User(user));
      });
  }

  loadBlockUsers(page: number): Observable<User[]> {
    return this.api
      .getCompleteResponse("blocks", {
        page: page,
      })
      .map((resp) => {
        this.localhostProvider.removeValue(KEYS.BlockListLength);
        this.localhostProvider.setValue(
          KEYS.BlockListLength,
          resp.headers.get("total-pages")
        );
        return resp.body.map((user) => new User(user));
      });
  }

  loadFemaleSimilarUsers(id: number): Observable<User[]> {
    return this.api
      .get("females/" + id + "/similars")
      .map((users) => users.map((user) => new User(user)));
  }

  loadMaleSimilarUsers(id: number): Observable<User[]> {
    return this.api
      .get("males/" + id + "/similars")
      .map((users) => users.map((user) => new User(user)));
  }

  loadRoyalPickup(): Observable<object> {
    return this.api.get("users/royal_pickup");
  }

  withdraw(param: Withdraw): Observable<any> {
    return this.api.delete("me/", false, param);
  }

  postUnregistersFormValue(param: Withdraw): Observable<any> {
    return this.api.post("unregisters#create", { param });
  }

  updateFixedPhrases(phrase: FixedPhrase): Observable<any> {
    return this.api.put("me/phrases/" + phrase.id, {
      phrase: {
        message: phrase.message,
        order: phrase.order,
      },
    });
  }

  loadFixedPhrases(): Observable<FixedPhrase[]> {
    return this.api.get("me/phrases");
  }

  deleteFixedPhrase(phraseId: number): Observable<FixedPhrase> {
    return this.api.delete("me/phrases/" + phraseId);
  }

  loadReplyFixedPhrase(): string {
    return DEFAULT_REPLY_PHRASE;
  }

  updateFaceWeight(
    userID: number,
    imageID: number,
    faceWeight: number
  ): Observable<any> {
    return this.api.put(
      "users/" + userID + "/user_images/" + imageID + "/face_weight",
      {
        face_weight: faceWeight,
      }
    );
  }

  updateSecretToggle(isSecret: boolean): Observable<any> {
    return this.api.put("me", {
      user: {
        is_secret: isSecret ? 1 : 0,
      },
    });
  }

  updateDiscloseImage(imageID: number, disclose: DiscloseImg): Observable<any> {
    return this.api.put("me/disclose", {
      image_id: imageID,
      disclose: disclose,
    });
  }

  updateImpression(userIds: number[]): Observable<any> {
    return this.api.post("users/update_impression", { user_ids: userIds });
  }

  generateUserIds(targetUsers: User[]): number[] {
    let userIds: number[] = [];
    targetUsers.forEach((user: User) => {
      userIds.push(user.id);
    });
    return userIds;
  }

  isCreatedAtAfterDay(createdAt: Date, day: number): boolean {
    createdAt.setDate(createdAt.getDate() + day);

    // 86400000 = 1day
    return new Date().getTime() - createdAt.getTime() > 86400000 * day;
  }

  isTimeBonus(me: Me): boolean {
    if (me.isFemale() || me.isPremium() || !me.isAdmin()) return;
    const now: Date = new Date();
    let isBonus: boolean = false;

    // 今が登録日時から22時間以内である
    let upper: Date = me.getCreatedAt();
    upper.setHours(upper.getHours() + 22);
    if (upper.getTime() > now.getTime()) {
      // 今が登録日時から10時間以降である
      let lower: Date = me.getCreatedAt();
      lower.setHours(lower.getHours() + 10);
      if (lower.getTime() < now.getTime()) {
        isBonus = true;
      }
    }
    return isBonus;
  }

  hide(userID: string): Observable<any> {
    return this.api.delete("hides/" + userID);
  }

  block(userID: string): Observable<any> {
    return this.api.delete("blocks/" + userID);
  }

  revive(friendshipId: string) {
    return this.api.put(
      "friendships/" + friendshipId,
      {
        friendship: { user_status: "normal" },
      },
      true
    );
  }

  skipDailySwipe(userID: string): Observable<any> {
    return this.api.post("users/" + userID + "/skip_daily_selection", {});
  }

  private noPageLoad(
    userType: string,
    params: SearchParams,
    sort?: string
  ): Observable<any[]> {
    let loadParams: any = {};
    if (sort) {
      loadParams = {
        query: JSON.stringify(params),
        sort: sort,
      };
    } else {
      loadParams = {
        query: JSON.stringify(params),
      };
    }
    return this.api.get("users/" + userType, false, loadParams);
  }

  private load(
    userType: string,
    page: number,
    params: SearchParams,
    userIds?: number[],
    sort?: string
  ): Observable<any[]> {
    let loadParams: any = {};
    if (sort && sort != "default") {
      if (userIds && userIds.length > 0) {
        loadParams = {
          page: page,
          query: JSON.stringify(params),
          user_ids: JSON.stringify(userIds),
          sort: sort,
        };
      } else {
        loadParams = {
          page: page,
          query: JSON.stringify(params),
          sort: sort,
        };
      }
    } else {
      if (userIds && userIds.length > 0) {
        loadParams = {
          page: page,
          query: JSON.stringify(params),
          user_ids: JSON.stringify(userIds),
        };
      } else {
        loadParams = {
          page: page,
          query: JSON.stringify(params),
        };
      }
    }
    return this.api.get("users/" + userType, false, loadParams);
  }

  //Fisher–Yates shuffle
  shuffleUsers(users: User[]): User[] {
    for (let i = users.length - 1; i >= 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [users[i], users[j]] = [users[j], users[i]];
    }
    return users;
  }

  removeDuplicateUser(users: User[]): User[] {
    return users.filter((targetUser, index, targetUsers) => {
      return (
        targetUsers.findIndex((compareUser) => {
          return targetUser.id === compareUser.id;
        }) === index
      );
    });
  }

  removeDeletedUser(targetUsers: User[]): User[] {
    return targetUsers.filter((targetUser, index, targetUsers) => {
      if (targetUser.getStatus() !== "deleted") {
        return targetUser;
      }
    });
  }

  removeTopImageNullUser(users: User[]): User[] {
    return users.filter((targetUser: User) => {
      if (targetUser.top_image) return targetUser;
    });
  }

  removeGyoshaUser(users: User[]): User[] {
    return users.filter((targetUser: User) => {
      if (!targetUser.isGyosha()) return targetUser;
    });
  }

  removeTopImageReviewingUser(users: User[]): User[] {
    return users.filter((targetUser: User) => {
      if (!targetUser.getTopImage().isBeforeReviewing()) return targetUser;
    });
  }

  getDailyMembership(): Observable<any> {
    return this.api.get("females/daily_membership_count");
  }

  showFreezedUserAlert(): void {
    const alert = this.alertCtrl.create({
      title: "",
      subTitle:
        "このユーザーは利用停止されています。<br/>お約束がある場合は、通報する前に、運営事務局へお問い合わせください。",
      buttons: [
        {
          text: "OK",
        },
      ],
    });
    alert.present();
    return;
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts